// 此文件由 scripts/generate-content.mjs 生成，请勿手工修改。
import slimes0 from '../content/slimes/aurora/slime.json';
import slimes1 from '../content/slimes/bubble/slime.json';
import slimes2 from '../content/slimes/green/slime.json';
import slimes3 from '../content/slimes/sinker/slime.json';
import drops0 from '../content/drops/water/drop.json';
import worlds0 from '../content/worlds/jelly-lab/world.json';
import levels0 from '../content/levels/001-slime-shake/level.json';
import levels1 from '../content/levels/002-bubble-lift/level.json';
import levels2 from '../content/levels/003-heavy-drop/level.json';
import { visualManifest } from './visual-manifest';

export const contentManifest = {
  slimes: [slimes0, slimes1, slimes2, slimes3],
  drops: [drops0],
  worlds: [worlds0],
  levels: [levels0, levels1, levels2],
  visuals: visualManifest,
} as const;
